import React, { useEffect, useState } from "react";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { connect, useSelector } from "react-redux";
import * as advertRedux from "modules/Advert/_redux/advertRedux";
import * as vehicleEndpoint from "modules/Advert/_redux/vehicleEndpoint";

// Sahibinden tarzı kademeli marka → model seçimi.
// Marka değişince model listesi yeniden çekilir; model değeri sıfırlanır.
// Redux'a iki ayrı slug yazar: vehicleBrand (id) ve vehicleModel (id).
function FLBrandModelCascade(props) {
  const { filters } = useSelector((state) => ({
    filters: state.advert.newAdvert.filters,
  }));

  const [brands, setBrands] = useState([]);
  const [models, setModels] = useState([]);
  const [loadingBrands, setLoadingBrands] = useState(false);
  const [loadingModels, setLoadingModels] = useState(false);

  const selectedBrandId = filters?.vehicleBrand || "";
  const selectedModelId = filters?.vehicleModel || "";

  useEffect(() => {
    let cancelled = false;
    setLoadingBrands(true);
    vehicleEndpoint
      .getBrands()
      .then((res) => {
        if (!cancelled) setBrands(res.data || []);
      })
      .finally(() => !cancelled && setLoadingBrands(false));
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if (!selectedBrandId) {
      setModels([]);
      return undefined;
    }
    let cancelled = false;
    setLoadingModels(true);
    vehicleEndpoint
      .getModelsByBrand(selectedBrandId)
      .then((res) => {
        if (!cancelled) setModels(res.data || []);
      })
      .finally(() => !cancelled && setLoadingModels(false));
    return () => {
      cancelled = true;
    };
  }, [selectedBrandId]);

  const selectedBrand = brands.find((b) => b.id === selectedBrandId || b._id === selectedBrandId) || null;
  const selectedModel = models.find((m) => m.id === selectedModelId || m._id === selectedModelId) || null;

  return (
    <div>
      <Autocomplete
        options={brands}
        loading={loadingBrands}
        getOptionLabel={(o) => o.name || ""}
        getOptionSelected={(o, v) => (o.id || o._id) === (v?.id || v?._id)}
        value={selectedBrand}
        onChange={(_, val) => {
          const id = val ? val.id || val._id : "";
          props.editNewAdvertFilters("vehicleBrand", id);
          // Marka değişince model'i sıfırla (eskiden seçili model yeni markaya ait olmayabilir).
          props.editNewAdvertFilters("vehicleModel", "");
        }}
        renderInput={(params) => (
          <TextField {...params} label="Marka" variant="outlined" margin="dense" fullWidth />
        )}
      />
      <Autocomplete
        options={models}
        loading={loadingModels}
        disabled={!selectedBrandId}
        getOptionLabel={(o) => o.name || ""}
        getOptionSelected={(o, v) => (o.id || o._id) === (v?.id || v?._id)}
        value={selectedModel}
        onChange={(_, val) => {
          const id = val ? val.id || val._id : "";
          props.editNewAdvertFilters("vehicleModel", id);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            label={selectedBrandId ? "Model" : "Önce marka seçiniz"}
            variant="outlined"
            margin="dense"
            fullWidth
          />
        )}
      />
    </div>
  );
}

export default connect(null, { ...advertRedux.actions })(FLBrandModelCascade);
